<p-accordion [multiple]="true">
  <p-accordionTab
    header="{{ 'Common.Form.Header' | translate }}"
    [(selected)]="isSearchFormOpen"
  >
    <ng-content *ngTemplateOutlet="settingSearchFormTemplate"></ng-content>
  </p-accordionTab>

  <p-accordionTab
    header="{{ 'ForwarderSetting.ExportRecommendForwarder.FormHeader.DataTable' | translate }}"
    [(selected)]="isDataTableOpen"
  >
    <ng-content *ngTemplateOutlet="settingDataTableTemplate"></ng-content>
  </p-accordionTab>
</p-accordion>

<ng-template #settingSearchFormTemplate>
  <form [ngStyle]="{'height':'100%'}" [formGroup]="searchForm">
    <div class="p-fluid formgrid grid">
      <div class="col-12 md:col-6 lg:col-3 mb-3">
        <label>{{ 'BookingSearch.Form.Forwarder' | translate }}</label>
        <div class="item">
          <p-dropdown
            formControlName="forwarderCode"
            placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
            [options]="forwarderOptions"
            [filter]="true"
            [showClear]="true"
          >
          </p-dropdown>
        </div>
      </div>

      <div class="col-12 md:col-6 lg:col-3 mb-3">
        <label>{{ 'DOQuery.Search.TradeTerm' | translate }}</label>
        <p-dropdown appendTo="body" formControlName="incoTerm"
          [options]="incotermOptions" [showClear]="true"
          placeholder="{{ 'Common.Message.ChooseOption' | translate }}">
        </p-dropdown>
      </div>

    <laas-location-cascade-dropdown
        formControlName="searchLocation"
        [showCountry]="true"
        [showCity]="true"
        [showArea]="false"
        [showExpressArea]="false"
        [showDistrict]="false"
        [useMultiSelectForCountry]="false"
        [useMultiSelectForCity]="true"
        [useMultiSelectForArea]="false"
        [useMultiSelectForExpressArea]="false"
        [useMultiSelectForDistrict]="false"
        countryLabel="{{ 'AddressMaintain.Form.Country' | translate }}"
        cityLabel="{{ 'AddressMaintain.Form.City' | translate }}"
        countryPlaceholder="{{ 'Common.DropDown.Select' | translate }}"
        cityPlaceholder="{{ 'Common.DropDown.Select' | translate }}"
        [allowAllOption]="false"
        [showClear]="true"
        [enableFilter]="true"
        [cssClasses]="'col-12 md:col-6 lg:col-3 mb-3'"
        (countryOptionsReady)="onCountryOptionsReady($event)"
        (cityOptionsReady)="onCityOptionsReady($event)">
      </laas-location-cascade-dropdown>
    </div>
    <div class="grid">
      <div class="col">
        <button pButton pRipple label="{{ 'Common.Button.Search' | translate }}" (click)="searchBtnClick()"></button>
        <button pButton pRipple label="{{ 'Common.Button.Reset' | translate }}" (click)="resetClickBtn()" class="p-button-secondary ml-2"></button>
        <button pButton pRipple label="{{ 'Common.Button.Import' | translate }}" icon="pi pi-upload" (click)="showImportDialog()" class="p-mr-2"></button>
      </div>
    </div>
  </form>
</ng-template>

<ng-template #settingDataTableTemplate>
  <div class="mt-2">
    <laas-data-table
      #dataTable
      [loading]="isLoading"
      [tableKey]="preferenceKey"
      [defaultColumns]="columns"
      [value]="dataRows"
      [lazy]="true"
      [editPermission]="editPermissionCode"
      [dataKey]="'rowId'"
      [selectable]="true"
      [(selectedRows)]="selectedRows"
      [createNewRow]="createNewRow"
      (createRow)="createRow($event)"
      [inputValid]="dataInputValid"
      (tableOnPage)="tablePageChange($event)"
      (tableOnSort)="tableSort($event)"
      (savedData)="saveData($event)"
      >
    <ng-template pTemplate="caption">
      <ng-container *ngIf="dataTable.isEdit">
        <button
          pButton
          type="button"
          label="{{ 'Common.Button.Delete' | translate }}"
          icon="fas fa-trash-alt"
          [disabled]="!dataTable.isInEditMode"
          (click)="deleteBtnClick()"
          class="p-button-danger p-button-raised ml-2">
        </button>
        <button
          pButton
          pRipple
          label="{{ 'Common.Button.Export' | translate }}"
          [disabled]="dataRows.length === 0"
          (click)="exportBtnClick()"
          class="p-ml-2">
        </button>
      </ng-container>
    </ng-template>
    <ng-template pTemplate="body" let-rowData let-columns="columns">
      <td *ngFor="let col of columns">
        <ng-container [ngSwitch]="col.field">
          <ng-container *ngSwitchDefault>
            <div class="overflow-text">
              {{ rowData[col.field] | replaceNullWith : "-" }}
            </div>
          </ng-container>
          <ng-container *ngSwitchCase="'deliveryCountry'">
            <div class="overflow-text">
              {{ rowData[col.field] | optionsMapping:countryConvertOptions | replaceNullWith:'-' }}
            </div>
          </ng-container>
          <ng-container *ngSwitchCase="'deliveryCity'">
            <div class="overflow-text">
              {{ rowData[col.field] | optionsMapping:cityCovnvertOptions | replaceNullWith:'-' }}
            </div>
          </ng-container>
          <ng-container *ngSwitchCase="'forwarderCode'">
            <div class="overflow-text">
              {{ rowData[col.field] | optionsMapping:forwarderOptions | replaceNullWith:'-' }}
            </div>
          </ng-container>
          <ng-container *ngSwitchCase="'createDt'">
            <div class="overflow-text">
              {{ rowData[col.field] | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}
            </div>
          </ng-container>
          <ng-container *ngSwitchCase="'createUser'">
            <div class="overflow-text">
              {{ rowData[col.field] | optionsMapping:userOptions | replaceNullWith:'-' }}
            </div>
          </ng-container>
          <ng-container *ngSwitchCase="'updateDt'">
            <div class="overflow-text">
              {{ rowData[col.field] | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}
            </div>
          </ng-container>
          <ng-container *ngSwitchCase="'updateUser'">
            <div class="overflow-text">
              {{ rowData[col.field] | optionsMapping:userOptions | replaceNullWith:'-' }}
            </div>
          </ng-container>
          <ng-container *ngSwitchCase="'rfqCountry'">
            <div class="overflow-text">
              {{ rowData[col.field] | optionsMapping:countryConvertOptions | optionsMapping:rfqCountryConvertOptions | replaceNullWith:'-' }}
            </div>
          </ng-container>
          <ng-container *ngSwitchCase="'rfqCity'">
            <div class="overflow-text">
              {{ rowData[col.field] | optionsMapping:cityCovnvertOptions | optionsMapping:rfqCityCovnvertOptions | replaceNullWith:'-' }}
            </div>
          </ng-container>
          <ng-container *ngSwitchCase="'incoTerm'">
            <div class="overflow-text">
              {{ rowData[col.field] | optionsMapping:incotermOptions | replaceNullWith:'-' }}
            </div>
          </ng-container>
          <ng-container *ngSwitchCase="'rfqIncoTerm'">
            <div class="overflow-text">
              {{ rowData[col.field] | optionsMapping:incotermOptions | replaceNullWith:'-' }}
            </div>
          </ng-container>
          <ng-container *ngSwitchCase="'consigneeKey'">
            <div class="overflow-text">
              {{ rowData[col.field] | optionsMapping:consigneeKeyOptions | replaceNullWith:'-' }}
            </div>
          </ng-container>
        </ng-container>
      </td>
    </ng-template>
      <ng-template pTemplate="bodyInputTemplate" let-rowData let-col="col">
        <ng-container [ngSwitch]="col.field">
          <ng-container *ngSwitchDefault>
            <div class="overflow-text">
              {{ rowData[col.field] | replaceNullWith : "-" }}
            </div>
          </ng-container>
          <ng-container *ngSwitchCase="'deliveryCountry'" class="p-fluid">
            <p-dropdown
              appendTo="body"
              class="p-fluid"
              placeholder="{{ rowData[col.field] ? (rowData[col.field] | optionsMapping : countryConvertOptions) : 'Common.Message.ChooseOption' | translate }}"
              [filter]="true"
              [options]="countryOptions"
              [(ngModel)]="rowData.deliveryCountry"
              (onChange)="onDeliveryCountryChange(rowData)"
              filterPlaceholder="{{'Common.PlaceHolder.EnterSearchCondition' | translate }}">
            </p-dropdown>
            <small *ngIf="!rowData[col.field]" class="alert">
              <div class="p-invalid">
                {{ 'Common.Button.Required' | translate }}
              </div>
            </small>
          </ng-container>
          <ng-container *ngSwitchCase="'deliveryCity'" class="p-fluid">
            <p-dropdown
              appendTo="body"
              class="p-fluid"
              placeholder="{{ rowData.deliveryCity ? rowData.deliveryCity : 'Common.Message.ChooseOption' | translate }}"
              [filter]="true"
              [options]="getDeliveryCity(rowData.deliveryCountry)"
              [(ngModel)]="rowData.deliveryCity"
              filterPlaceholder="{{'Common.PlaceHolder.EnterSearchCondition' | translate }}">
            </p-dropdown>
            <small *ngIf="!rowData[col.field]" class="alert">
              <div class="p-invalid">
                {{ 'Common.Button.Required' | translate }}
              </div>
            </small>
          </ng-container>
          <ng-container *ngSwitchCase="'weightLowerLimit'">
            <div class="overflow-text">
              <p-inputNumber
                [(ngModel)]="rowData[col.field]"
                mode="decimal"
                [min]="0"
                [max]="9999"
                [minFractionDigits]="0"
                [maxFractionDigits]="2">
              </p-inputNumber>
            </div>
            <small *ngIf="rowData[col.field] == null" class="alert">
              <div class="p-invalid">
                {{ 'Common.Button.Required' | translate }}
              </div>
            </small>
          </ng-container>
          <ng-container *ngSwitchCase="'weightUpperLimit'">
            <div class="overflow-text">
              <p-inputNumber
                [(ngModel)]="rowData[col.field]"
                mode="decimal"
                [min]="0"
                [max]="9999"
                [minFractionDigits]="0"
                [maxFractionDigits]="2">
              </p-inputNumber>
            </div>
            <small *ngIf="rowData[col.field] == null" class="alert">
              <div class="p-invalid">
                {{ 'Common.Button.Required' | translate }}
              </div>
            </small>
          </ng-container>
          <ng-container *ngSwitchCase="'forwarderCode'" class="p-fluid">
            <p-dropdown
              appendTo="body"
              class="p-fluid"
              placeholder="{{ rowData[col.field] ? (rowData[col.field] | optionsMapping : forwarderOptions) : 'Common.Message.ChooseOption' | translate }}"
              [filter]="true"
              [options]="forwarderOptions"
              [(ngModel)]="rowData[col.field]"
              (onChange)="onForwarderChange($event, rowData)"
              filterPlaceholder="{{'Common.PlaceHolder.EnterSearchCondition' | translate }}">
            </p-dropdown>
            <small *ngIf="!rowData[col.field]" class="alert">
              <div class="p-invalid">
                {{ 'Common.Button.Required' | translate }}
              </div>
            </small>
          </ng-container>
          <ng-container *ngSwitchCase="'direct'" class="p-fluid">
            <p-dropdown
              appendTo="body"
              class="p-fluid"
              placeholder="{{ rowData[col.field] ? (rowData[col.field] | optionsMapping : directOptions) : 'Common.Message.ChooseOption' | translate }}"
              [options]="directOptions"
              [(ngModel)]="rowData[col.field]"
              filterPlaceholder="{{'Common.PlaceHolder.EnterSearchCondition' | translate }}">
            </p-dropdown>
            <small *ngIf="!rowData[col.field]" class="alert">
              <div class="p-invalid">
                {{ 'Common.Button.Required' | translate }}
              </div>
            </small>
          </ng-container>
          <ng-container *ngSwitchCase="'incoTerm'" class="p-fluid">
            <p-multiSelect
              appendTo="body"
              class="p-fluid"
              [(ngModel)]="rowData[col.field]"
              [options]="incotermOptions"
              placeholder="{{ rowData[col.field] ? (rowData[col.field] | optionsMapping : incotermOptions) : 'Common.Message.ChooseOption' | translate }}"
              [filter]="true"
              filterBy="label">
            </p-multiSelect>
            <small *ngIf="!rowData[col.field]" class="alert">
              <div class="p-invalid">
                {{ 'Common.Button.Required' | translate }}
              </div>
            </small>
          </ng-container>
          <ng-container *ngSwitchCase="'rfqCountry'" class="p-fluid">
            <p-dropdown
              appendTo="body"
              class="p-fluid"
              placeholder="{{ rowData[col.field] ? (rowData[col.field] | optionsMapping : countryOptions) : 'Common.Message.ChooseOption' | translate }}"
              [filter]="true"
              [options]="countryOptions"
              [(ngModel)]="rowData.rfqCountry"
              (onChange)="onRfqCountryChange(rowData)"
              filterPlaceholder="{{'Common.PlaceHolder.EnterSearchCondition' | translate }}">
            </p-dropdown>
            <small *ngIf="!rowData[col.field]" class="alert">
              <div class="p-invalid">
                {{ 'Common.Button.Required' | translate }}
              </div>
            </small>
          </ng-container>
          <ng-container *ngSwitchCase="'rfqCity'" class="p-fluid">
            <p-dropdown
              appendTo="body"
              class="p-fluid"
              placeholder="{{ rowData.rfqCity ? rowData.rfqCity : 'Common.Message.ChooseOption' | translate }}"
              [filter]="true"
              [options]="rowData.isForwarderExpress ? getRfqCityExpressOptions(rowData.rfqCountry) : getRfqCityOptions(rowData.rfqCountry) "
              [(ngModel)]="rowData.rfqCity"
              filterPlaceholder="{{'Common.PlaceHolder.EnterSearchCondition' | translate }}">
            </p-dropdown>
            <small *ngIf="!rowData[col.field]" class="alert">
              <div class="p-invalid">
                {{ 'Common.Button.Required' | translate }}
              </div>
            </small>
          </ng-container>
          <ng-container *ngSwitchCase="'rfqIncoTerm'" class="p-fluid">
            <p-dropdown
              appendTo="body"
              class="p-fluid"
              placeholder="{{ rowData[col.field] ? (rowData[col.field] | optionsMapping : incotermOptions) : 'Common.Message.ChooseOption' | translate }}"
              [filter]="true"
              [options]="rowData.isForwarderExpress ? rfqIncotermOptionsForIsExpress : rfqIncotermOptions"
              [(ngModel)]="rowData[col.field]"
              (onChange)="onRfqIncoTermChange($event,rowData)"
              filterPlaceholder="{{'Common.PlaceHolder.EnterSearchCondition' | translate }}">
            </p-dropdown>
            <small *ngIf="!rowData[col.field]" class="alert">
              <div class="p-invalid">
                {{ 'Common.Button.Required' | translate }}
              </div>
            </small>
          </ng-container>
          <ng-container *ngSwitchCase="'createDt'">
            <div class="overflow-text">
              {{ rowData[col.field] | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}
            </div>
          </ng-container>
          <ng-container *ngSwitchCase="'updateDt'">
            <div class="overflow-text">
              {{ rowData[col.field] | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}
            </div>
          </ng-container>
          <ng-container *ngSwitchCase="'consigneeKey'" class="p-fluid">
            <laas-customer-dropdown
              [(ngModel)]="rowData[col.field]"
              [isSingle]="true"
              [divClass]="'p-fluid'"
              (onDataLoaded)="onCustomerListLoaded($event)"
              (onOptionDataChange)="onTableConsigneeChange($event, rowData)">
            </laas-customer-dropdown>
          </ng-container>
        </ng-container>
      </ng-template>

      <ng-template pTemplate="bodyOutputTemplate" let-rowData let-col="col">
        <ng-container [ngSwitch]="col.field">
          <ng-container *ngSwitchDefault>
            <div class="overflow-text">
              {{ rowData[col.field] | replaceNullWith : "-" }}
            </div>
          </ng-container>
          <ng-container *ngSwitchCase="'deliveryCountry'">
            <div class="overflow-text">
              {{ rowData[col.field] | optionsMapping:countryConvertOptions | replaceNullWith:'-' }}
            </div>
          </ng-container>
          <ng-container *ngSwitchCase="'deliveryCity'">
            <div class="overflow-text">
              {{ rowData[col.field] | optionsMapping:cityCovnvertOptions | replaceNullWith:'-' }}
            </div>
          </ng-container>
          <ng-container *ngSwitchCase="'forwarderCode'">
            <div class="overflow-text">
              {{ rowData[col.field] | optionsMapping:forwarderOptions | replaceNullWith:'-' }}
            </div>
          </ng-container>
          <ng-container *ngSwitchCase="'createDt'">
            <div class="overflow-text">
              {{ rowData[col.field] | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}
            </div>
          </ng-container>
          <ng-container *ngSwitchCase="'createUser'">
            <div class="overflow-text">
              {{ rowData[col.field] | optionsMapping:userOptions | replaceNullWith:'-' }}
            </div>
          </ng-container>
          <ng-container *ngSwitchCase="'updateDt'">
            <div class="overflow-text">
              {{ rowData[col.field] | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}
            </div>
          </ng-container>
          <ng-container *ngSwitchCase="'updateUser'">
            <div class="overflow-text">
              {{ rowData[col.field] | optionsMapping:userOptions | replaceNullWith:'-' }}
            </div>
          </ng-container>
          <ng-container *ngSwitchCase="'rfqCountry'">
            <div class="overflow-text">
              {{ rowData[col.field] | optionsMapping:countryConvertOptions | optionsMapping:rfqCountryConvertOptions | replaceNullWith:'-' }}
            </div>
          </ng-container>
          <ng-container *ngSwitchCase="'rfqCity'">
            <div class="overflow-text">
              {{ rowData[col.field] | optionsMapping:cityCovnvertOptions | optionsMapping:rfqCityCovnvertOptions  | replaceNullWith:'-' }}
            </div>
          </ng-container>
          <ng-container *ngSwitchCase="'incoTerm'">
            <div class="overflow-text">
              {{ rowData[col.field] | optionsMapping:incotermOptions | replaceNullWith:'-' }}
            </div>
          </ng-container>
          <ng-container *ngSwitchCase="'rfqIncoTerm'">
            <div class="overflow-text">
              {{ rowData[col.field] | optionsMapping:incotermOptions | replaceNullWith:'-' }}
            </div>
          </ng-container>
          <ng-container *ngSwitchCase="'consigneeKey'">
            <div class="overflow-text">
              {{ rowData[col.field] | optionsMapping:consigneeKeyOptions | replaceNullWith:'-' }}
            </div>
          </ng-container>
        </ng-container>
      </ng-template>
    </laas-data-table>
  </div>
</ng-template>

<p-dialog header="Export貨代批次匯入" [(visible)]="displayImportDialog" [style]="{width: '50vw'}" [modal]="true" [baseZIndex]="100">

  <div *ngIf="isImportDialogLoading" class="loadingMask">
    <p-progressSpinner></p-progressSpinner>
  </div>

  <div class="p-fluid">
    <div class="col-12 md:col-6 lg:col-4 mb-3">
      <label>{{ 'ForwarderSetting.UploadDailog.ImportFacility' | translate }}</label>
      <p-multiSelect
          [filter]="true"
          [options]="facilityOptions"
          [(ngModel)]="facilityList"
          [appendTo]="'body'"
          placeholder="{{ 'Common.Message.ChooseOption' | translate }}">
      </p-multiSelect>
    </div>
    <div class="flex justify-content-between">
      <input type="file" #fileInput style="display: none" (change)="onFileSelected($event)" accept=".xls,.xlsx,.xlsm">
      <button pButton pRipple label="{{ 'Common.Button.Select' | translate }}" icon="pi pi-check" class="p-button-success mr-2" (click)="fileInput.click()"></button>
      <button pButton pRipple label="{{ 'Common.Button.FileUpload' | translate }}" icon="pi pi-upload" class="mr-2" (click)="uploadFile()" [disabled]="!isFileSelected"></button>
      <button pButton pRipple label="{{ 'Common.Button.DownloadTemplate' | translate }}" icon="pi pi-download" class="p-button-secondary" (click)="downloadTemplateBtn()"></button>
    </div>

    <div *ngIf="isFileSelected" class="mt-3">
      File: {{ selectedFileName }}
    </div>
  </div>
</p-dialog>
